import React, { useMemo } from 'react';
import { classifyBillLifecycle, isBudgetBill } from '../utils/billLifecycleStages';

const SHORT_LABEL_BASE = {
    introduction: 'Intro',
    policy_own: 'Policy',
    policy_other: 'Policy',
    fiscal_own: 'Fiscal',
    fiscal_other: 'Fiscal',
    budget_own: 'Budget',
    budget_other: 'Budget',
    floor_own: 'Floor',
    floor_other: 'Floor',
    concurrence: 'Concur.',
    enrollment: 'Enroll.',
    governor: 'Gov Desk',
};

const chamberLabel = (chamber, house) => {
    if (!chamber || !house) return '';
    const otherHouse = house === 'Assembly' ? 'Senate' : 'Assembly';
    return chamber === 'own' ? house : otherHouse;
};

const chamberAbbr = (chamber) => (chamber === 'Assembly' ? 'Asm.' : chamber === 'Senate' ? 'Sen.' : '');

const GOVERNOR_STATUS_LABELS = {
    'Signed by Governor': 'Signed',
    Chaptered: 'Chapt.',
    Vetoed: 'Veto',
};

const governorLabel = (step, billStatus) => {
    if (!step.enteredDate) return null;
    return GOVERNOR_STATUS_LABELS[billStatus] || null;
};

const shortLabel = (step, chamber, billStatus) => {
    if (step.key === 'governor') {
        const base = governorLabel(step, billStatus) || SHORT_LABEL_BASE.governor;
        return base;
    }
    const base = SHORT_LABEL_BASE[step.key] || step.label;
    const abbr = chamberAbbr(chamber);
    return abbr ? `${abbr} ${base}` : base;
};

const BillLifecycleProgress = ({ bill, billHistory }) => {
    const steps = useMemo(() => {
        if (!bill?.house) return [];
        return classifyBillLifecycle({
            house: bill.house,
            status: bill.status,
            billHistory,
            isBudget: isBudgetBill(bill.LatestVersion),
        });
    }, [bill, billHistory]);

    if (!steps.length) return null;

    return (
        <div className="bp-lifecycle">
            <div className="bp-section-label">Bill Lifecycle</div>
            <div className="bp-lifecycle-track">
                {steps.map((step, idx) => {
                    const chamber = chamberLabel(step.chamber, bill.house);
                    const chamberClass = chamber ? ` bp-lifecycle-node--chamber-${chamber.toLowerCase()}` : '';
                    return (
                        <React.Fragment key={step.key}>
                            <div className={`bp-lifecycle-node-col bp-lifecycle-node--${step.status}${chamberClass}`}>
                                <span className="bp-lifecycle-node">
                                    <span className="bp-lifecycle-dot" />
                                </span>
                                <div className="bp-lifecycle-node-label">{shortLabel(step, chamber, bill.status)}</div>
                            </div>
                            {idx < steps.length - 1 && (
                                <div className="bp-lifecycle-connector-wrap">
                                    <span className={`bp-lifecycle-connector-h${(step.status === 'complete' || step.status === 'skipped') ? ' bp-lifecycle-connector-h--filled' : ''}`} />
                                </div>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default BillLifecycleProgress;
